import reduce from 'lodash/reduce'
import * as Redux from 'redux'
import * as Constants from './constants'
import * as Types from './types'

export const successConstant = (prefix: Types.RequestActionPrefix) => `${prefix}_${Constants.SUCCESS}`
export const errorConstant = (prefix: Types.RequestActionPrefix) => `${prefix}_${Constants.ERROR}`
export const requestConstant = (prefix: Types.RequestActionPrefix) => `${prefix}_${Constants.REQUEST}`

export const switchSuccessConstant = (prefix: Types.RequestActionPrefix) =>
  `${Constants.SWITCH}_${prefix}_${Constants.SUCCESS}`
export const switchErrorConstant = (prefix: Types.RequestActionPrefix) =>
  `${Constants.SWITCH}_${prefix}_${Constants.ERROR}`
export const switchRequestConstant = (prefix: Types.RequestActionPrefix) =>
  `${Constants.SWITCH}_${prefix}_${Constants.REQUEST}`

export const rasaApiSuccessConstant = (prefix: Types.RequestActionPrefix) =>
  `${prefix}_${successConstant(Constants.RASA_API)}`
export const rasaApiErrorConstant = (prefix: Types.RequestActionPrefix) =>
  `${prefix}_${errorConstant(Constants.RASA_API)}`
export const rasaApiRequestConstant = (prefix: Types.RequestActionPrefix) =>
  `${prefix}_${requestConstant(Constants.RASA_API)}`

export const integrationsApiSuccessConstant = (prefix: Types.RequestActionPrefix) =>
  `${prefix}_${successConstant(Constants.RASA_INTEGRATIONS_API)}`
export const integrationsApiErrorConstant = (prefix: Types.RequestActionPrefix) =>
  `${prefix}_${errorConstant(Constants.RASA_INTEGRATIONS_API)}`
export const integrationsApiRequestConstant = (prefix: Types.RequestActionPrefix) =>
  `${prefix}_${requestConstant(Constants.RASA_INTEGRATIONS_API)}`

interface WithDispatch extends Object {
  dispatch: Redux.Dispatch<Redux.Action>,
}

export const withDispatch:
  (data: object[], dispatch: Redux.Dispatch<Redux.Action>) => WithDispatch[] =
    (data, dispatch) => data.map((d) => ({...d, dispatch}))

// Generic Reducer Chain for a provided type - takes a list of Reducers and returns the state
export const reducerChain = <T>(reducers: Array<Redux.Reducer<T>>): Redux.Reducer<T> => {
  return (state: T, action: any) => {
    return reduce(reducers, (s, r) => r(s, action), state)
  }
}



// WEBPACK FOOTER //
// ./src/request/utils.ts